<!--
<div class="ite-toolbar fixed-toolbar" #toolbar></div>

<div class="ite-toolbar" #toolbar >
    <quill-editor [(ngModel)]="value.innerHTML"
      #quillRef
      [modules]="quillConfig"
      (onSelectionChanged)="onSelectionChanged($event)"
      (onContentChanged)="onSave($event)">
    </quill-editor>
</div> -->

<div class="ite-toolbar-wrapper">
  <div class="ite-toolbar" #toolbar >
    <quill-editor [(ngModel)]="content"
      #quillRef
      [modules]="quillConfig"
      (onEditorCreated)="onEditorCreated()"
     (onContentChanged)="autoResize()">
    </quill-editor>
  </div>
</div>
